import React, { useContext, useState } from 'react'
import { TbMapPin, TbWorld } from 'react-icons/tb'
import SHSpeakerCard from '../../../components/SHSpeakerCard/SHSpeakerCard'
import './SHEventSpeakers.css'
import { useLanguage } from '../../../../../LanguageProvider';
import AddSpeakerModal from '../../../components/AddSpeakerModal/AddSpeakerModal';
import Services from '../../../../../services/Services';
import { useToaster } from '../../../../../ToasterProvider';
import { GeneralContext } from '../../../../../GeneralProvider';
import AddSponsorModal from '../../../components/AddSponsorModal/AddSponsorModal';
import SHSponsorCard from '../../../components/SHSponsorCard/SHSponsorCard';

export default function SHEventSponsors({ event, isAdmin, getEventDetails }) {
    const { setCreateProjectLoading } = useContext(GeneralContext);
    const { getTranslation } = useLanguage();
    const { toastError, toastSuccess } = useToaster();
    const token = localStorage.getItem("token")
    const [isModalOpen, setIsModalOpen] = useState(false)

    const handleCloseModal = () => {
        setIsModalOpen(false)
    }

    const handleAddSponsor = (companyTitle, companyAbout, sponsorshipType, sponsorshipAbout, image) => {
        setCreateProjectLoading(true)
        Services.SocialHiveAddSponsor(token, event.channelID, event.eventID, companyTitle, companyAbout, sponsorshipType, sponsorshipAbout, image)
            .then((res) => {
                if (res.data.status) {
                    toastSuccess(getTranslation("successMessage"))
                    getEventDetails()
                    handleCloseModal()
                } else {
                    toastError(getTranslation("somethingWentWrong"));
                }
                setCreateProjectLoading(false)
            })
            .catch((err) => {
                console.error(err);
                toastError(getTranslation("somethingWentWrong"));
            });
    }

    const monthKeys = [
        'january', 'february', 'march', 'april',
        'may', 'june', 'july', 'august',
        'september', 'october', 'november', 'december'
    ];

    function formatToMonthDashDay(timestamp) {
        const date = new Date(timestamp * 1000);
        const monthKey = monthKeys[date.getMonth()];
        const monthName = getTranslation(monthKey);           // örn. "October" veya "Ekim"
        const shortMonth = monthName.slice(0, 3);            // "Oct" veya "Eki"
        const day = String(date.getDate()).padStart(2, '0'); // "03"
        return `${shortMonth} - ${day}`;
    }

    return (
        <div className="sh-info-main" style={{ height: 'fit-content' }}>
            <div className="sh-image-wrapper" style={{ padding: 0 }}>
                <img src={event.cover} height={250} alt={event.title} className="sh-card-image" />
                <span className="sh-event-card-date-badge">{formatToMonthDashDay(event.eventStartDateTime)}</span>
            </div>
            <h1 className="sh-event-title">{event.title}</h1>
            {event?.isOnline === "1" ?
                <div className="sh-location">
                    <TbWorld className="sh-icon" />
                    <span>{event?.website}</span>
                </div>
                :
                <div className="sh-location">
                    <TbMapPin className="sh-icon" />
                    <span>{event?.locationAddress}</span>
                </div>
            }

            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
                <span className='sh-speakers-title'>{getTranslation('sponsors')}</span>
                {isAdmin === "1" &&
                    <span className="sh-details-title" onClick={() => setIsModalOpen(true)} >
                        <span>{getTranslation('addNewSponsor')}</span>
                    </span>}
            </div>

            {event.sponsors ? (
                <div className="social-hive-speakers-grid">
                    {event.sponsors.map((sponsor, index) => (
                        <SHSponsorCard
                            isAdmin={isAdmin}
                            key={index}
                            name={sponsor.companyTitle}
                            image={sponsor.image}
                            title={sponsor.sponsorshipType}
                            eventID={event.eventID}
                            sponsorID={sponsor.sponsorID}
                            getEventDetails={getEventDetails}
                        />
                    ))}
                </div>
            ) : (
                <div className="sh-location">
                    <span>{getTranslation('noSponsorsYet')}</span>
                </div>
            )}

            <AddSponsorModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onCreate={handleAddSponsor}
                isWorkspace={true}
            />
        </div>
    )
}
